export default {
      id: "play-arrow-usage",
      viewBox: "0 0 24 24",
      url: "/assets/svg/" + "sprite.svg#play-arrow-usage",
      toString: function () {
        return this.url;
      }
    }